import { FC } from "react";
import { Button } from "@mui/material";
import { FormattedMessage } from "react-intl";

export interface ISubmitButtonProps {
  disabled?: boolean;
}

export const SubmitButton: FC<ISubmitButtonProps> = props => {
  const { disabled = false } = props;

  return (
    <Button type="submit" variant="contained" disabled={disabled}>
      <FormattedMessage id="form.buttons.apply" />
    </Button>
  );
};
